import { create } from 'zustand'

interface UrlWebSocket {
    urlWebSocket: string | null
    setUrlWebSocket: (urlWebSocket: string | null) => void
}

export const useUrlWebSocket = create<UrlWebSocket>((set) => ({
    urlWebSocket: null,
    setUrlWebSocket: (urlWebSocket) => set({ urlWebSocket }),
}))

